import SectionHead from "./SectionHead";
import { editorPicks } from "@/mocks/homeData";

export default function EditorPicks() {
  return (
    <section className="px-4 py-12 md:px-10 md:py-16">
      <SectionHead
        index="05"
        title="编辑精选"
        en="Editor's Picks"
        desc="不追速度的三篇。它们更像版面上的留白，给今天的热闹补上一点解释。"
      />

      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          {editorPicks.map((pick, idx) => (
            <a
              key={pick.title}
              href="#top"
              className="group flex cursor-pointer gap-5 border-b border-background-200 py-6 first:pt-0 last:border-0"
            >
              <span className="font-heading text-sm font-black text-primary-500">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {pick.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{pick.summary}</p>
                <div className="mt-3 font-label text-[11px] tracking-wider text-foreground-400">
                  · {pick.author}
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="lg:col-span-5">
          <div className="h-[240px] w-full overflow-hidden rounded-lg bg-background-100 md:h-[340px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20desk%20scene%2C%20open%20notebook%20and%20a%20cup%20of%20coffee%20on%20cream%20linen%20surface%2C%20soft%20diffused%20daylight%20from%20the%20side%2C%20muted%20crimson%20accent%20detail%2C%20vintage%20film%20grain%2C%20generous%20negative%20space%2C%20calm%20magazine%20feature%20photography%2C%20warm%20neutral%20background%2C%20no%20text%2C%20harmonious%20composition&width=1400&height=900&seq=heiliaozhan-desk-02&orientation=landscape"
              alt="黑料总站编辑精选视觉 · 站内内容整理与更新记录"
              title="黑料总站 编辑精选 内容整理"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="mt-5 flex items-start gap-3 border-l-2 border-accent-400 pl-4">
            <p className="text-sm leading-loose text-foreground-600">
              版面上的每一个位置都对应一次取舍。编辑精选存在的意义，是让今天的热点之外，还留着可以慢慢读的部分。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}